import { createMuiTheme } from '@material-ui/core/styles';


export const defaultTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    }
});

const paletteOverrides = {
    primary: {
        main: '#D4002A'
    },
    secondary: {
        light: '#E4F1FD',
        main: '#4081a1',
        dark: '#455460',
        muted: '#AFB9C1',
    },
    border: {
        main: '#ECECEC'
    },
};

export const theme = createMuiTheme({
    typography: {
        fontFamily: "'Lato', sans-serif",
        useNextVariants: true,
        h1: {
            fontFamily: "'Playfair Display', serif",
            fontSize: '3.5rem',
            fontWeight: 500,
            lineHeight: '56px',
            letterSpacing: .1,
            margin: '1rem 0',
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '2.5rem',
                lineHeight: '1em',
            },
        },
        h2: {
            fontFamily: "'Playfair Display', serif",
            fontSize: '3rem',
            fontWeight: 500,
            lineHeight: '1.1em',
            margin: '.8rem 0',
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '2.5rem',
                lineHeight: '1em',
            },
        },
        h3: {
            fontFamily: "'Playfair Display', serif",
            fontSize: '2.5rem',
            fontWeight: 500,
            letterSpacing: '.08px',
            lineHeight: '1.1em',
            margin: '.7rem 0',
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '2rem',
                lineHeight: '1em',
            },
        },
        h4: {
            fontFamily: "'Playfair Display', serif",
            fontSize: '2rem',
            lineHeight: '1em'
        },
        h5: {
            fontFamily: "'Playfair Display', serif",
            fontSize: '1.6rem',
            lineHeight: '1em',
        },
        h6: {
            
        },
        subtitle1: {
            fontSize: '1rem',
            lineHeight: '1.1em',
            letterSpacing: 2,
            margin: '.5rem 0',
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '12px',
                lineHeight: '1em',
            },
        },
        subtitle2: {
            fontSize: 14,
            letterSpacing: 1.5,
            lineHeight: '17px',
            margin: '.5rem 0',
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '12px',
                lineHeight: '1em',
            },
        },
        body1: {
            fontSize: '1.2rem',
            lineHeight: '1.5em',
            margin: '1rem 0',
        },
        body2: {
            fontSize: '1rem',
            lineHeight: '24px',
            letterSpacing: .3,
            fontWeight: 300,
            color: paletteOverrides.secondary.dark,
            [defaultTheme.breakpoints.down('xs')]: {
                fontSize: '14px',
                lineHeight: '20px',
            },
        }
    },
    overrides: {
        MuiButton: {
            root: {
                '&:hover': {
                    color: 'initial'
                }
            },
            contained: {
                fontWeight: 'bold',
                '&:hover': {
                    color: 'white'
                }
            },
        },
    },
    palette: paletteOverrides,
});